import { render, staticRenderFns } from "./modal-editapprovers.vue?vue&type=template&id=145811b0&scoped=true&"
import script from "./modal-editapprovers.vue?vue&type=script&lang=js&"
export * from "./modal-editapprovers.vue?vue&type=script&lang=js&"
import style0 from "./modal-editapprovers.vue?vue&type=style&index=0&id=145811b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145811b0",
  null
  
)

export default component.exports